import Vue from 'vue'
import Router from 'vue-router'
import VueMetarial from 'vue-material'
import Top from '@/components/Top'
import Main from '@/components/Main'
import Index from '@/components/Index'
import Redirect from '@/components/Redirect'
import Credit from '@/components/Credit'
import Const from '@/mixins/commonConst'
import Utils from '@/mixins/utils'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import VueLazyload from 'vue-lazyload'
import Ads from 'vue-google-adsense'

Vue.use(VueMetarial)

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: '/static/img/error.png',
  loading: '/static/img/loading.gif',
  attempt: 1
})
Vue.use(Router)
Vue.mixin(Const)
Vue.mixin(Utils)

Vue.use(require('vue-script2'))
Vue.use(Ads.Adsense)
Vue.use(Ads.InArticleAdsense)
Vue.use(Ads.InFeedAdsense)

export default new Router({
//  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/Top',
      name: 'Top',
      component: Top
    },
    {
      path: '/contents',
      name: 'Main',
      component: Main,
      props: {default: true}
    },
    {
      path: '/redirect',
      name: 'Redirect',
      component: Redirect
    },
    {
      path: '/credit',
      name: 'Credit',
      component: Credit
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js